import { CultureInfo } from "../../../../Global/Dom/CultureInfo";
import { createElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { CalendarFrame, CalendarType } from "../XGControls/Frames/CalendarFrame";
import { IContentBuilder } from "./IContentBuilder";
/**
 * @internal
 */
export class CalendarDateTextBuilder implements IContentBuilder {
    private _frame: CalendarFrame;
    private _textElement: HTMLElement;
    // @ts-ignore // nevyužito, ale ponecháno
    private static _localizationsObject = {
        monday: "GUI-300874",
        tuesday: "GUI-300876",
        wednesday: "GUI-300878",
        thursday: "GUI-300880",
        friday: "GUI-300882",
        saturday: "GUI-300884",
        sunday: "GUI-300886",

        january: "GUI-643669",
        february: "GUI-643670",
        march: "GUI-643671",
        april: "GUI-643672",
        may: "GUI-643673",
        june: "GUI-643674",
        july: "GUI-643675",
        august: "GUI-643676",
        september: "GUI-643677",
        october: "GUI-643678",
        november: "GUI-643679",
        december: "GUI-643680",
    };

    // @ts-ignore // nevyužito, ale ponecháno
    private static _monthNames = ["january", "february", "march", "april", "may", "june", "july", "august", "septemper", "october", "november", "december"];

    constructor(frame: CalendarFrame) {
        this._frame = frame;
    }

    private _createElement(): HTMLElement {
        const htmlElement = createElement({ classes: "date-info-toolbar" });
        this._textElement = document.createElement("span");

        htmlElement.appendChild(this._textElement);
        this._registerEventAndLoadData();

        return htmlElement;
    }

    private _registerEventAndLoadData(): void {
        const f_loadData = () => {
            const curCult = CultureInfo.getCultureInfo();
            const curCultName = curCult.name;
            let options: Intl.DateTimeFormatOptions = { year: "numeric", month: "long" };

            if (this._frame.calendarType == CalendarType.day) {
                options = { weekday: "short", year: "numeric", month: "long", day: "numeric" };
            }

            const r = new RegExp(`(${this._frame.currentDate.getFullYear()})`); //`
            let dateText = this._frame.currentDate.toLocaleDateString(curCultName, options);
            if (this._frame.calendarType != CalendarType.day)
                dateText = (dateText[0].toUpperCase() + dateText.substr(1));

            this._textElement.innerHTML = dateText.replace(r, "<span class='year-text'>$1</span>&nbsp;<i class='icon ui-chevron-bottom'></i>");
        };

        this._frame.updateDate.add((_cf, _data) => {
            f_loadData();
        });
        this._frame.updateRange.add((_cf, _dataa) => {
            f_loadData();
        });

        f_loadData();
    }

    public build(): Promise<HTMLElement> {
        return Promise.resolve(this._createElement());
    }
}
